Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "ErrorTooltip2890269065",
  {"error":"ErrorTooltip2890269065--error","left":"ErrorTooltip2890269065--left","bottom":"ErrorTooltip2890269065--bottom","root":"ErrorTooltip2890269065--root"},
  "",
  7,
  "ErrorTooltip2890269065"
);

